import styled from '@emotion/styled';

export const UsersContainer = styled.div`
  min-height: 100vh;
`;

export const UsersHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  h2 {
    margin: 0 0 0.5rem 0;
    color: #1e293b;
    font-size: 24px;
    font-weight: 600;
  }

  p {
    margin: 0;
    color: #64748b;
    font-size: 14px;
  }
`;

export const UsersTableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
`;
